<template>
  <div>
    2
    <div>
      <el-card shadow="never">
        <el-form :inline="true" :model="formInline" class="demo-form-inline">
          <el-form-item label="售后搜索">
            <el-input v-model="formInline.user" placeholder="请输入订单号/售后编号/手机号/商品ID"></el-input>
          </el-form-item>
          <el-form-item label="申请时间">
            <el-date-picker
                v-model="formInline.value1"
                type="date"
                placeholder="请选择">
            </el-date-picker>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" @click="onSubmit">查询</el-button>
          </el-form-item>
        </el-form>

      </el-card>
      <el-card shadow="never">
        <div style="display: flex;justify-content: space-between; align-items: center;width: 100%;">
          <div style="display: inline-block;">
            <el-badge value="14" class="item">
              <el-button @click="changeIndex(1)" :class="{'selected1': selectedIndex ===1}" size="small">待处理
              </el-button>
            </el-badge>
            <el-badge value="30" class="item">
              <el-button @click="changeIndex(2)" :class="{'selected1': selectedIndex ===2}" size="small">退款进行中
              </el-button>
            </el-badge>
            <el-badge value="14" class="item">
              <el-button @click="changeIndex(3)" :class="{'selected1': selectedIndex ===3}" size="small">已完成
              </el-button>
            </el-badge>
            <el-badge value="30" class="item">
              <el-button @click="changeIndex(4)" :class="{'selected1': selectedIndex ===4}" size="small">已拒绝
              </el-button>
            </el-badge>
          </div>
          <div style="width:300px;display: inline-block;margin-right: 20px;">
            <!--        goodsExport-->
            <el-button v-if="isGoodsExport" size="medium" type="primary">导出</el-button>
            <!--        batchGoodsConfirm-->
            <el-button v-if="isBatchGoodsConfirm" size="medium" type="primary">批量审核确认</el-button>
          </div>
        </div>
      </el-card>
      <el-card shadow="never">
        <el-table
            :data="tableData"
            border
            style="width: 100%">
          <el-table-column
              prop="date"
              label="订单号"
              width="180">
          </el-table-column>
          <el-table-column
              prop="name"
              label="申请时间"
              width="180">
          </el-table-column>
          <el-table-column
              prop="address"
              label="售后单号">
          </el-table-column>
          <el-table-column
              prop="address"
              label="商品信息">
          </el-table-column>
          <el-table-column
              prop="address"
              label="下单信息">
          </el-table-column>
          <el-table-column
              prop="address"
              label="金额">
          </el-table-column>
          <el-table-column
              prop="address"
              label="数量">
          </el-table-column>
          <el-table-column
              prop="address"
              label="售后类型">
          </el-table-column>
          <el-table-column
              prop="address"
              label="发货状态">
          </el-table-column>
          <el-table-column
              prop="address"
              label="售后原因">
          </el-table-column>
          <el-table-column
              prop="address"
              label="补充说明">
          </el-table-column>
          <el-table-column
              prop="address"
              label="凭证">
          </el-table-column>
          <el-table-column
              prop="address"
              label="售后状态">
          </el-table-column>
          <el-table-column
              prop="address"
              label="驳回原因">
          </el-table-column>
          <el-table-column
              prop="countdown"
              label="驳回原因">
          </el-table-column>
          <el-table-column
              fixed="right"
              align="center"
              width="350"
              label="操作">
            <template slot-scope="scope">
              <!-- <el-button size="mini" v-for="(item, index) in buttonList_table" :key="index" :type="item.buttonType"
                           @click="callFunctionRow(item, index, scope.row)">{{ item.displayName }}
                </el-button> -->
              <div>
                <!--              refuseGoods   refuseGoodsDetail-->


                <el-button type="text"> {{ timeFormat(scope.row.deadline) }}</el-button>
                <el-button v-if="isRefundGoods" @click="refundGoods" size="mini" type="primary">同意退货</el-button>
                <el-button v-if="isRefuseGoods" @click="refuse" size="mini" type="danger">拒绝</el-button>
                <el-button @click="goDetails" v-if="IsRefuseGoodsDetail" size="mini" type="success">查看详情</el-button>
              </div>
            </template>
          </el-table-column>
        </el-table>
        <el-pagination class="pagination" layout="total, sizes, prev, pager, next, jumper"
                       @size-change="handleSizeChange"
                       @current-change="handleCurrentChange" :total="total" :page-sizes="[10, 20, 30, 40, 50, 100]">
        </el-pagination>
      </el-card>
    </div>
  </div>
</template>
<script>
import {getButtonList} from "../../../promissionRouter";
export default {
  name: "RefundGoods",
  data() {
    return {

      querylist:[],
      isGoodsExport: false,
      isBatchGoodsConfirm: false,
      isRefundGoods: false,
      isRefuseGoods: false,
      IsRefuseGoodsDetail: false,
      tableData: [
        {
          id: 1,
          orderNumber: 'Order1',
          createTime: '2022-01-01 09:00:00',
          deadline: '2024-01-01 10:00:00'
        },
        {
          id: 2,
          orderNumber: 'Order2',
          createTime: '2022-01-02 10:00:00',
          deadline: '2023-09-06 12:00:00'
        }
      ],
      selectedIndex: 1,
      formInline: {
        user: '',
        region: '',
        value1: ''
      },
      total: 0,
    }
  },



    created() {
      this.getTableData()
    },
    mounted() {
      // const myScroll = new IScroll('#scroll', {
      //   //按照需求添加横向滚动的配置项
      // });
      //更新
      // console.log('myScroll',myScroll)
      // myScroll.refresh();

      // this.getSpusOnSale();
      let routers = window.localStorage.router
          ? JSON.parse(window.localStorage.router)
          : [];
      //第一种写法，每个页面都需要写方法，但是可以做特性化处理
      // this.getButtonList(routers);

      //第二种写法，封装到 permissionRouter.js 中
      var buttonList = getButtonList(this.$route.path, routers);
      if (buttonList && buttonList.length > 0) {
        const toolBarButtonList = buttonList.filter((item) => {
          return item.buttonShow === 10;
        });
        this.buttonList_toolBar = toolBarButtonList;
        if (this.buttonList_toolBar && this.buttonList_toolBar.length > 0) {
          this.buttonList_toolBar.forEach((item, index) => {
            if (item.buttonFunc === "goodsExport") {
              this.isGoodsExport = true;
            }
            if (item.buttonFunc === "batchGoodsConfirm") {
              this.isBatchGoodsConfirm = true;
            }
          })
        }
        console.log(toolBarButtonList, 'toolBarButtonList')
        const tableButtonList = buttonList.filter((item) => {
          return item.buttonShow === 20;
        });
        this.buttonList_table = tableButtonList;
        if (this.buttonList_table && this.buttonList_table.length > 0) {
          this.buttonList_table.forEach((item, index) => {
            if (item.buttonFunc === "refundGoods") {
              this.isRefundGoods = true;
            }
            if (item.buttonFunc === "refuseGoods") {
              this.isRefuseGoods = true;
            }
            if (item.buttonFunc === "refuseGoodsDetail") {
              this.IsRefuseGoodsDetail = true;
            }
          })
        }
      }
      // console.log('buttonList', buttonList)
      // console.log('toolBarButtonList', this.buttonList_toolBar)
      // console.log('buttonList_table', this.buttonList_table)
    },
    methods: {

      getTableData() {
        this.tableData.forEach((ele) => {
          //调用定时器传递
          this.daojishi(ele);
          // 如果数据不更新的话，增加下面代码
          this.tableData.splice(1, 0);
        });
      },
      // 倒计时定时器
      daojishi(row) {
        // 绑定定时器
        row.countDown = setInterval(() => {
          console.log('11')
          // 计算剩余时间戳
          let residue = new Date(row.date).getTime() - new Date().getTime();
          if (residue > 0) {
            // 对每行的剩余时间进行设置
            row.lastTime = residue;
          } else {
            // 清除定时器
            clearInterval(row.countDown);
          }
        }, 1000);

      },
      // 剩余时间格式化
      timeFormat(times) {
        if (times > 0) {
          let days = this.addZero(
              Math.floor(times / 1000 / 60 / 60 / 24)
          ); //天
          let hours = this.addZero(
              Math.floor((times / 1000 / 60 / 60) % 24)
          ); //时
          let minutes = this.addZero(
              Math.floor((times / 1000 / 60) % 60)
          ); //分
          let seconds = this.addZero(Math.floor((times / 1000) % 60)); //秒
          return `${days}天${hours}小时${minutes}分钟${seconds}秒`;
        } else {
          return "已超时";
        }
      },
      // 个位补零
      addZero(d) {
        return parseInt(d) < 10 ? "0" + d : d;
      },
      goDetails() {
        this.$router.push('/AfterSalesService/AfterSaleList/Detail')
      },
      refuse() {
        this.$confirm("确认拒绝退货吗?", "提示", {
          closeOnClickModal: false,
          //type: 'warning'
        })
            .then(() => {

            })
            .catch((err) => {
              console.log(err)
            });
      },
      refundGoods() {
        this.$confirm("确认退货吗?", "提示", {
          closeOnClickModal: false,
          //type: 'warning'
        })
            .then(() => {

            })
            .catch((err) => {
              console.log(err)
            });
      },
      changeIndex(i) {
        this.selectedIndex = Number(i);
      },
      onSubmit() {
        console.log('submit!');
      },
      handleSizeChange(val) {
        // this.pageSize = val
        // this.pageIndex = 1
        // this.getTableList()
      },
      handleCurrentChange(val) {
        // this.pageIndex = val
        // this.getTableList()
      },
    }
  }
</script>


<style scoped>
.item {
  margin-top: 10px;
  margin-right: 40px;
}

/deep/ .selected1 {
  background-color: #ecf5ff;
  color: #409eff;
}

.pagination {
  text-align: right;
  margin-top: 15px;
}
</style>